import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { Button, Table } from "flowbite-react";
import { MdVerified } from "react-icons/md";
import { FaTrashAlt } from "react-icons/fa";
import ListModal from "./ListModal";
import { formatFollowers, renderEngagementRate } from "../../services/format";
import { getInfluencerByUserId } from "../../api/instagram";
import { useLists } from "../../contexts/ListsContext";
import AvatarWithPlaceholder from "./AvatarWithPlaceholder";

const Lookalike = ({ lookalike, removeOption, handleRemove, network }) => {
  const [openModal, setOpenModal] = useState(false);
  const [lookalikeLists, setLookalikeLists] = useState([]);
  const [loadingInfluencerData, setLoadingInfluencerData] = useState(false);
  const { refreshLists } = useLists();

  useEffect(() => {
    const fetchInfluencer = async () => {
      setLoadingInfluencerData(true);

      try {
        const influencer = await getInfluencerByUserId(lookalike.userId);

        if (influencer && influencer.lists.length) {
          setLookalikeLists(influencer.lists);
        } else {
          setLookalikeLists([]);
        }
      } catch (error) {
        console.error(error);
        toast.error(error?.message || 'An error occurred while fetching influencer data.');
      } finally {
        setLoadingInfluencerData(false);
      }
    }

    if (lookalike) {
      fetchInfluencer();
    }
  }, [lookalike]);

  return (
    <Table.Row
      className="bg-white"
      key={lookalike.userId}
      style={{ opacity: lookalike.deleted ? 0.5 : 1 }}
    >
      <Table.Cell>
        <a
          href={lookalike.profile.url}
          className="flex gap-4 items-center"
          target="_blank"
          rel="noreferrer"
        >
          <AvatarWithPlaceholder img={lookalike.profile.picture} />
          <div>
            <div className="text-gray-900 flex gap-1 items-center">
              {lookalike.profile.fullname}
              {lookalike.profile.isVerified && <MdVerified color="#3b82f6" />}
            </div>
            <div className="text-xs mt-1">@{lookalike.profile.username || lookalike.profile.handle}</div>
          </div>
        </a>
      </Table.Cell>
      <Table.Cell>
        <div className="text-lg text-gray-900">{formatFollowers(lookalike.profile.followers)}</div>
        <div className="text-xs">Followers</div>
      </Table.Cell>
      <Table.Cell>
        <div className="text-lg text-gray-900">{formatFollowers(lookalike.profile.engagements)}</div>
        <div className="text-xs">Engagements</div>
      </Table.Cell>
      <Table.Cell>
        <div className="text-lg text-gray-900">{renderEngagementRate(lookalike.profile.engagementRate)}</div>
        <div className="text-xs">Engagement rate</div>
      </Table.Cell>
      <Table.Cell>
        {removeOption ? (
          <Button onClick={() => handleRemove(lookalike)}>
            <FaTrashAlt />
          </Button>
        ) : (
          <>
            <Button onClick={() => setOpenModal(true)}>Manage Lists</Button>
            <ListModal
              openModal={openModal}
              setOpenModal={setOpenModal}
              loadingInfluencerData={loadingInfluencerData}
              lookalike={lookalike}
              refreshLists={refreshLists}
              lookalikeLists={lookalikeLists}
              network={network}
            />
          </>
        )}
      </Table.Cell>
    </Table.Row>
  )
}

export default Lookalike;